export default {
    updateInProgress: false,
    messages: [],
    vehicleMakes: [],
    vehicleModels: [],
};
